import { configureStore, getDefaultMiddleware, EnhancedStore, Middleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer, { RootState } from './root-reducer';
import rootSaga from './root-saga';
import initAPI from '../api/iv-back';

const saga = createSagaMiddleware();

export default function initStore({
  baseURL,
  otherMiddlewares = [],
}: {
  baseURL: string;
  otherMiddlewares?: Middleware[];
}): EnhancedStore<RootState> {
  const store: EnhancedStore<RootState> = configureStore({
    reducer: rootReducer,
    middleware: [
      ...getDefaultMiddleware<RootState, { serializableCheck: false }>({
        serializableCheck: false,
      }),
      saga,
      ...otherMiddlewares,
    ],
    devTools: process.env.NODE_ENV !== 'production',
  });

  initAPI({
    baseURL,
  });
  saga.run(rootSaga);
  return store;
}
